import React, { Component } from 'react';
import {Link} from 'react-router-dom';
// import $ from 'jquery';
import {login, resetPassword} from '../helpers/auth';
import Error from '../helpers/Error';

// var insertScript = function(src){
// 	var script = document.createElement('script');
// 	script.type = 'text/javascript';
// 	script.src = src;
// 	document.body.appendChild(script);
// }

export default class Login extends Component {

    constructor(props) {
    	super(props);
    	this.state = {err: null, status: null};

    }

    handleSubmit = (e) => {
    	e.preventDefault();

    	if(this.email.value === "") {
    		this.setState({err: 'Email is required!', status: 'err'});
    		
    	}
    	else if(this.pw.value === "") {
    		this.setState({err: 'Password is required!', status: 'err'});
    		
    	}
		else {
	    	login(this.email.value, this.pw.value)
	    		.catch((error) => {
	    			this.setState({err: "Invalid username/password.", status: 'err'});
	    		});
		}
    }

    resetPassword = () => {
    	resetPassword(this.email.value)
    		.then(() => this.setState({err: `Password reset email send to ${this.email.value}`, status: 'err'}))
    		.catch((error) => this.setState({err: "Email Address Not Found.", status: 'err'}));
    }

  	render() {
	    return (

	      	<div className="login-bg">
			    <div className="login-intro">
			        <div className="col-md-4 col-md-offset-4">
			            <form onSubmit={this.handleSubmit.bind(this)} name="loginForm" >
			                <div className="panel panel-info">
			                    <div className="panel-heading">Login - 
			                    	<Link to="/"> andrideng.com</Link>
			                    </div>
			                    <div className="panel-body">
			                        <div className="form-group">
			                            <input ref={(email) => this.email = email} className="form-control text-center" placeholder="Email" type="email" required=""></input>

			                        </div>

			                        <div className="form-group">
			                            <input ref={(pw) => this.pw = pw} className="form-control text-center" placeholder="Password" type="password" required=""></input>
			                        </div>
			                        <Error err={this.state.err} status={this.state.status}/>
			                        

			                    </div>
			                    <div className="panel-footer">
			                        <button className="btn btn-lg btn-info" type="submit">Sign in</button>
			                    </div>
			                </div>
			            </form>
			        </div>
			    </div>
			</div>



	    );
  }
}



// WEBPACK FOOTER //
// ./src/guest/Login.js